define(
	'ProductDetails.ImageGallery.View.Site'
,	[
		'ProductDetails.ImageGallery.View'
	,	'Backbone.CompositeView'
	,	'Utilities.ResizeImage'
	,	'SocialSharing.Flyout.Hover.View'

	,	'product_details_image_gallery.tpl'

	,	'Backbone'
	,	'underscore'
	,	'Utils'

	,	'jquery.zoom'
	,	'jQuery.bxSlider'
	]
,	function (
		View
	,	BackboneCompositeView
	,	resizeImage
	,	SocialSharingFlyoutHoverView

	,	product_details_image_gallery_tpl

	,	Backbone
	,	_
	,	Utils
	)
{
	'use strict';

	_.extend(View.prototype, {
		buildSliderPager: function (slide_index){
				var image = this.images[slide_index];
				if (image)
				{
					if(image.video){
							return '<img src="' + resizeImage('https://speedmaster79.com/SSP Applications/Speedmaster79/Live/img/video_thumbnail.jpg', 'tinythumb') + '" alt="' + image.altimagetext + '">';
					} else {
							return '<img src="' + resizeImage(image.url, 'tinythumb') + '" alt="' + image.altimagetext + '">';
					}
				}
			}
		})


})
;
